import React from "react";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import Card from "../../../components/Card";
import TitlePage from "../../../components/TitlePage";
import SwitchField from "../../../components/SwitchField";
import Button from "../../../components/Button";
import Spinner from "../../../components/Spinner";
import styles from "./Configuration.module.css";

export default function ConfigurationComponents({
  configData,
  onConfigChange,
  onSave,
  onReset,
  isLoading,
  isSaving,
  businessName,
}) {
  const localize = useLocalization();

  return (
    <Card>
      <Spinner loading={isLoading}>
        <div className={styles.header}>
          <TitlePage text={localize.getText("businessConfiguration")} />
          <p className={styles.subtitle}>
            {localize.getText("configurationDesc")}{" "}
            {businessName && `untuk ${businessName}`}
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.actionBar}>
            <div className={styles.quickActions}>
              <span className={styles.quickActionsLabel}>
                {localize.getText("quickActions")}:
              </span>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={onReset}
                className={styles.quickActionBtn}
                label={localize.getText("resetToDefault")}
                leftIcon={<i className="fas fa-undo"></i>}
              />
            </div>

            <Button
              variant="primary"
              onClick={onSave}
              disabled={isSaving}
              className={styles.saveButton}
              leftIcon={
                isSaving ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-save"></i>
                )
              }
              label={
                isSaving
                  ? localize.getText("saving")
                  : localize.getText("saveConfiguration")
              }
            />
          </div>

          <div className={styles.settingsList}>
            <div className={styles.settingCard}>
              <div className={styles.settingHeader}>
                <div className={styles.settingInfo}>
                  <h6 className={styles.settingTitle}>
                    <i className="fas fa-shield-alt me-2"></i>
                    {localize.getText("dataAccessControl")}
                  </h6>
                  <p className={styles.settingDescription}>
                    {localize.getText("restrictToOwnerDataDesc")}
                  </p>
                </div>

                <div className={styles.settingToggle}>
                  <SwitchField
                    value={configData.restrict_to_owner_data}
                    onChange={(value) =>
                      onConfigChange("restrict_to_owner_data", value)
                    }
                  />
                </div>
              </div>

              <div className={styles.settingDetails}>
                <div className={styles.settingStatus}>
                  {configData.restrict_to_owner_data ? (
                    <span className={styles.statusEnabled}>
                      <i className="fas fa-check-circle me-1"></i>
                      {localize.getText("enabled")} -{" "}
                      {localize.getText("staffCanOnlySeeOwnData")}
                    </span>
                  ) : (
                    <span className={styles.statusDisabled}>
                      <i className="fas fa-times-circle me-1"></i>
                      {localize.getText("disabled")} -{" "}
                      {localize.getText("staffCanSeeAllData")}
                    </span>
                  )}
                </div>

                <div className={styles.settingImpact}>
                  <small className={styles.impactLabel}>
                    <i className="fas fa-info-circle me-1"></i>
                    {localize.getText("impact")}:
                  </small>
                  <ul className={styles.impactList}>
                    <li>{localize.getText("affectsPaymentDataAccess")}</li>
                    <li>{localize.getText("affectsExportPaymentAccess")}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className={styles.settingCard}>
              <div className={styles.settingHeader}>
                <div className={styles.settingInfo}>
                  <h6 className={styles.settingTitle}>
                    <i className="fas fa-cog me-2"></i>
                    {localize.getText("futureSettings")}
                  </h6>
                  <p className={styles.settingDescription}>
                    {localize.getText("moreSettingsComingSoon")}
                  </p>
                </div>
              </div>

              <div className={styles.settingDetails}>
                <div className={styles.comingSoon}>
                  <i className="fas fa-rocket me-2"></i>
                  {localize.getText("comingSoon")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spinner>
    </Card>
  );
}
